<template>
  <div class="low-stock">
    <form-data :references.sync="formReferences" :model="supplierObj" ref="supplierOrderRef">
      <template slot="extraDetails" class="mb-3">
        <v-form ref="orderItems">
          <v-row>
            <v-col cols="10" class="pl-0 pr-0 pb-0" v-if="isItemsSelected">
              <v-btn class="ml-2 mb-2" color="primary" @click="createSupplierOrder">{{ $t('message.warehouse.createOrder') }}</v-btn>
            </v-col>
          </v-row>
          <template v-if="loadingSupplierProducts">
            <v-skeleton-loader type="table"></v-skeleton-loader>
          </template>
          <template v-else>
            <v-row class="border mt-1 pa-0">
              <span>
                <v-checkbox dense hide-details color="primary" v-model="isSelectAll" @change="selectAllRows" class="mt-0"></v-checkbox>
              </span>
              <v-col cols="2 pa-1" class="ml-1 adjust-product-width">{{ $t('message.warehouse.product') }}*</v-col>
              <v-col cols="1 pa-1" class="adjust-unit-width">{{ $t('message.product.unit') }}</v-col>
              <v-col cols="1 pa-1" class="adjust-qty-width">{{ $t('message.whOrder.orderQty') }}*</v-col>
              <v-col cols="1 pa-1" class="text-right">{{ $t('message.whOrder.minQty') }}</v-col>
              <v-col cols="1 pa-1" class="text-right">{{ $t('message.whOrder.availQty') }}</v-col>
              <v-col cols="1 pa-1" class="text-right">{{ $t('message.whOrder.orderedQty') }}</v-col>
              <v-col cols="1 pa-1" class="adjust-qty-width text-right">{{ $t("message.whOrder.unitCost") }}</v-col>
              <v-col cols="1 pa-1" class="text-right">{{ $t('message.common.total') }}</v-col>
              <v-col cols="2 pa-1" class="">{{ $t('message.common.comments') }}</v-col>
            </v-row>
            <template v-if="orderItems && orderItems.length > 0">
              <v-virtual-scroll :items="orderItems" :item-height="eachRowHeight" :height="heightOfScroll">
                <template v-slot:default="{ item, index }">
                  <v-row class="order_item_table" no-gutters>
                    <v-checkbox dense hide-details color="primary" v-model="item.isSelected" @change="checkIfAllIsSelected" class="mt-0 pa-0"></v-checkbox>
                    <v-col cols="2" class="pa-1 adjust-product-width">
                      <template v-if="item.olditem ? item.olditem.productid : false">
                        <v-row no-gutters>
                          <v-col cols="12" class="pa-0 text-truncate">
                            <span class="caption"></span>{{ item.productnumber || '-' }} {{ item.productname || '-' }}
                          </v-col>
                          <v-col cols="12" class="pa-0 text-truncate">
                            <span v-if="!supplierObj.supplierid || (supplierObj.supplierid && supplierObj.supplierid.length > 1)" class="font-italic">({{ item.suppliername }})</span>
                          </v-col>
                        </v-row>
                      </template>
                    </v-col>
                    <v-col cols="1" class="pa-1 adjust-unit-width">
                      <v-autocomplete @change="unitCalculation(index)" outlined dense :items="listOfUnitMatrix.filter(x => x.productid === item.productid && x.issupplier)" item-text="productunit_name" autocomplete="off" :rules="$_requiredValidation" v-model="item.unitid"
                        item-value="id" @click:clear="$nextTick(() => item.unitid = null)" ref="unitid" hide-details :disabled="['partiallyreceived', 'received'].includes(supplierObj.status)"></v-autocomplete>
                    </v-col>
                    <v-col cols="1" class="pa-1 adjust-qty-width">
                      <v-text-field v-model="item.qty" :disabled="supplierObj.status === 'received'" outlined dense  :ref="`qty_${index}`"
                        :rules="item.qty ? $_norwegianNumberValidation : (item.isSelected ? $_requiredValidation : [])" hide-details  @change="calculateTotalValue(index)"
                        :placeholder="$t('message.common.typeHere')"></v-text-field>
                    </v-col>
                    <v-col cols="1" class="pa-1 text-right">
                      {{ item.minqty }}
                    </v-col>
                    <v-col cols="1" class="pa-1 text-right">
                      {{ item.available }}
                    </v-col>
                    <v-col cols="1" class="pa-1 text-right">
                      {{ item.orderedqty }}
                    </v-col>
                    <v-col cols="1" class="pa-1 adjust-qty-width">
                      <v-text-field v-model="item.discountedprice" class="text-right-align-price" outlined dense :disabled="userDetails.role_id !== 1"
                        :rules="item.discountedprice ? $_norwegianNumberValidation : []" hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col cols="1" class="pa-1 text-right">
                      {{ item.totalprice | replaceDotWithComma }} {{ item.suppliercurrency || '' }}
                    </v-col>
                    <v-col cols="2" class="pa-1">
                      <template v-if="item.olditem ? item.olditem.comments : false">
                        {{ item.comments || '' }}
                      </template>
                      <v-text-field v-else outlined dense v-model="item.comments" type="text" hide-details :placeholder="$t('message.common.typeHere')"></v-text-field>
                    </v-col>
                  </v-row>
                </template>
              </v-virtual-scroll>
            </template>
          </template>
        </v-form>
      </template>
    </form-data>
    <v-dialog v-model="createOrderObj.dialog" persistent width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.confirmation') }} </v-card-title>
        <v-card-text class="pa-5">
          <h3>{{ $t('message.warehouse.warningAboutOrder') }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" @click="createOrderObj.createAndEmail">{{ $t('message.warehouse.createAndEmail') }} </v-btn>
          <v-btn color="info" :loading="loading" @click="createOrderObj.createOnly">{{ $t('message.warehouse.createOnly') }}</v-btn>
          <v-btn color="error" @click="createOrderObj.onCancel">{{ $t('message.common.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
export default {
  data () {
    return {
      listOfUnitMatrix: [],
      listOfCurrencyList: [],
      supplierObj: {
        id: 0,
        status: 'draft',
        priority: 'medium',
        datePicker: '',
        estimateDatePicker: ''
      },
      loading: false,
      orderItems: [],
      loadingSupplierProducts: false,
      createOrderObj: {
        dialog: false
      },
      heightOfScroll: 700,
      eachRowHeight: 50,
      isSelectAll: false
    }
  },
  components: {
    'form-data': FormTemplate
  },
  created () {
    this.getAllCurrencyList()
    this.getAllProductUnitMatrices()
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfSuppliers', 'listOfWarehouse', 'userDetails']),
    isItemsSelected () {
      return this.orderItems.filter(x => x.isSelected).length >= 1
    },
    pageHeight () {
      return document.body.scrollHeight
    },
    formReferences () {
      return {
        title: this.$t('message.warehouse.lowStockTitle'),
        properties: [{
          model: 'orderdate',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg2 sm6 xs12',
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.whOrder.orderDate')
        }, {
          model: 'supplierid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          items: this.listOfSuppliers,
          term: 'supplier',
          click: (term) => null,
          is_list: false,
          multiple: true,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.order.supplier'),
          class: 'lg3 sm6',
          change: this.addProductsToList
        }, {
          model: 'warehouseid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          click: (term) => null,
          is_list: false,
          term: '',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse'),
          class: 'lg2 sm6'
        }, {
          model: 'priority',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          items: this.$_priorityList,
          term: '',
          is_list: true,
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.layout.priority'),
          class: 'lg2 sm6'
        }, {
          model: 'estimated_date',
          rules: [],
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg2 sm6 xs12',
          picker: 'estimateDatePicker',
          menu: 'dateesMenu',
          color: 'primary lighten-1',
          label: this.$t('message.whOrder.estimated')
        }],
        buttons: [{
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push('/w_h/order'),
          label: this.$t('message.common.backToList'),
          to: '/w_h/order',
          is_show: true
        }]
      }
    }
  },
  mounted () {
    this.supplierObj.orderdate = this.$formatter.formatDate(new Date(), 'YYYY-MM-DD', 'DD.MM.YYYY')
    if (this.supplierObj.id) {
      this.getSingleRecordHandler()
      window.history.pushState({ path: this.$route.path }, '', this.$route.path)
    }
    // read supporting list items
    this.$store.dispatch('getSupplierList')
    this.$store.dispatch('getWarehouse')
      .then(() => {
        if (!this.supplierObj.id) this.setDefaultValues({ prop: 'warehouseid', list: this.listOfWarehouse })
      })
  },
  watch: {
    'supplierObj.datePicker' (val) {
      if (val) {
        this.supplierObj.orderdate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'supplierObj.estimateDatePicker' (val) {
      if (val) {
        this.supplierObj.estimated_date = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  methods: {
    getAllProductUnitMatrices () {
      this.loadingSupplierProducts = true
      const query = {
        expand: [{
          model: 'ProductUnit',
          on_field: 'id',
          on_parent_field: 'unitid'
        }]
      }
      this.$_executeApi('post', 'productunitmatrix/query', query)
        .then((response) => {
          this.listOfUnitMatrix = response.data
          this.addProductsToList()
        })
    },
    getAllCurrencyList () {
      this.$_executeApi('get', 'currencies/get_all_currency_list')
        .then((response) => {
          response.data.sort((a, b) => a.name.localeCompare(b.name))
          this.listOfCurrencyList = response.data
        })
    },
    saveOrderItemsHandler (isSendMail) {
      if (this.$refs.supplierOrderRef.$refs.validateForm.validate()) {
        if (this.$refs.orderItems.validate()) {
          this.loading = true
          const transformModelData = { date: { list: ['orderdate', 'estimated_date'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
          let modelObj = this.$formatter.cloneVariable(this.supplierObj)
          modelObj = this.$_formatModel(modelObj, transformModelData)
          modelObj.type = 'supplier'
          modelObj.supplierid = 0
          const modelList = this.$formatter.cloneVariable(this.orderItems.filter(x => x.isSelected))
          modelList.map(x => {
            x.qty = this.$formatter.replaceCommaWithDot(x.qty)
            x.receivedqty = this.$formatter.replaceCommaWithDot(x.receivedqty)
            x.minqty = this.$formatter.replaceCommaWithDot(x.minqty)
            x.unitqty = this.$formatter.replaceCommaWithDot(x.unitqty)
            x.discountedprice = this.$formatter.replaceCommaWithDot(x.discountedprice)
            x.costpricenok = this.$formatter.replaceCommaWithDot(x.costpricenok)
            x.qty = x.qty || 0
            x.costprice = x.discountedprice || 0
            x.costpriceperunit = x.discountedprice || 0
            x.minqty = x.minqty || 0
            x.unitqty = x.unitqty || 0
            if (!x.unitqty) {
              const unitObj = this.listOfUnitMatrix.find(y => y.productid === x.productid && y.issupplier)
              if (unitObj) x.unitqty = unitObj.qty
            }
            x.receivedorders = []
            return x
          })
          const bulkSupplierOrders = { warehouseorder: modelObj, items: modelList, createandsendmail: isSendMail }
          this.$_executeApi('post', 'warehouseorders/create_bulk_supplier_orders', bulkSupplierOrders)
            .finally(() => {
              this.loading = false
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.warehouse.ordersCreatedSuccess') })
              this.createOrderObj.dialog = false
              this.$router.push('/w_h/order')
            })
        } else {
          this.loading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        }
      }
    },
    async unitCalculation (index) {
      await this.updateProductQtyValues(index, true)
      this.calculateTotalValue(index)
    },
    updateProductQtyValues (index, applyToMinQty) {
      return new Promise((resolve) => {
        if (index >= 0) {
          const getObj = this.$formatter.cloneVariable(this.orderItems[index])
          const unitObj = this.listOfUnitMatrix.find(x => x.id === getObj.unitid)
          if (unitObj) {
            if (applyToMinQty) {
              getObj.qty = this.$formatter.replaceDotWithComma(unitObj.orderqty)
              getObj.minqty = this.$formatter.replaceDotWithComma(unitObj.minqty)
            }
            getObj.unitid = unitObj.id
            getObj.orderedqty = this.$formatter.replaceDotWithComma(this.$formatter.replaceCommaWithDot(getObj.qty || 0) * unitObj.qty)
            getObj.unitqty = unitObj.qty
          }
          const getExistingItems = this.$formatter.cloneVariable(this.orderItems)
          getExistingItems.splice(index, 1, getObj)
          this.orderItems = [...getExistingItems.filter(x => x)]
          resolve()
        } else resolve()
      })
    },
    setDefaultValues (data) {
      const { list, prop } = data
      if (list && list.length === 1) {
        const model = Object.assign({ ...this.supplierObj }, { [prop]: list[0].id })
        this.supplierObj = model
      }
    },
    addProductsToList () {
      this.loadingSupplierProducts = true
      this.$_executeApi('post', 'stocks/get_available_products_for_low_stock_proposal', this.supplierObj.supplierid || [])
        .then(response => {
          const getProducts = response.data
          const productsList = []
          getProducts.map(x => {
            x.products = [{ id: x.product.id, productName: x.product.number ? `${x.product.number} - ${x.product.name}` : x.product.name }]
            x.productid = x.product.id
            x.isSelected = false
            x.productnumber = x.product.number
            x.productname = x.product.name
            let unitObj = this.listOfUnitMatrix.find(y => y.productid === x.productid && y.issupplier)
            if (!unitObj) unitObj = { id: null, orderqty: 0, minqty: 0, qty: 0 }
            x.unitid = unitObj.id
            x.qty = unitObj && unitObj.orderqty ? this.$formatter.replaceDotWithComma(unitObj.orderqty) : null
            x.minqty = unitObj && unitObj.minqty ? this.$formatter.replaceDotWithComma(unitObj.minqty) : null
            let orderedQty = 0
            if (unitObj && unitObj.orderqty) orderedQty = (unitObj.orderqty * unitObj.qty)
            orderedQty = this.$formatter.replaceDotWithComma(orderedQty)
            x.orderedqty = orderedQty
            x.unitqty = unitObj.qty
            x.minstock = this.$formatter.replaceDotWithComma(x.product.minstock || 0)
            x.available = this.$formatter.replaceDotWithComma(x.product.available || 0)
            x.isbatch = x.product.batchrequired
            x.supplierDiscount = this.$formatter.replaceDotWithComma(x.supplierdiscount || 0)
            x.discountedprice = this.$formatter.replaceDotWithComma(x.supplierdiscount || 0)
            x.costpricenok = x.product.costprice ? this.$formatter.replaceCommaWithDot(x.product.costprice) : 0
            x.olditem = this.$formatter.cloneVariable(x)
            productsList.push(x)
            x.id = 0
            return x
          })
          setTimeout(() => {
            if (getProducts.length >= 14) this.heightOfScroll = 14 * this.eachRowHeight
            else this.heightOfScroll = getProducts.length * this.eachRowHeight + 10
            this.orderItems = getProducts
            this.calculateTotalValue(-1, true)
            this.loadingSupplierProducts = false
          })
        })
        .catch(() => {
          this.loadingSupplierProducts = false
        })
    },
    calculateTotalValue (index, init = false) {
      this.updateProductQtyValues(index)
      const items = this.orderItems
      let total = 0
      let suppliercurrency = ''
      items.map((x, i) => {
        suppliercurrency = x.suppliercurrency
        const qty = +this.$formatter.replaceCommaWithDot(x.orderedqty || 0)
        let price
        if (x.id) {
          price = +this.$formatter.replaceCommaWithDot(x.discountedprice || 0)
        } else {
          price = +this.$formatter.replaceCommaWithDot(x.supplierDiscount || 0)
        }
        total += qty * price
        if (index >= 0 && i === index) {
          this.$set(this.orderItems, i, { ...this.orderItems[index], totalprice: qty * price })
        } else if (init) {
          this.$set(this.orderItems, i, { ...this.orderItems[i], totalprice: qty * price })
        }
      })
      this.totalPrice = total
      this.supplierCurrency = suppliercurrency
    },
    selectAllRows () {
      const products = this.$formatter.cloneVariable(this.orderItems)
      products.map(x => {
        x.isSelected = this.isSelectAll
        return x
      })
      this.orderItems = products
    },
    checkIfAllIsSelected () {
      const products = this.$formatter.cloneVariable(this.orderItems)
      const isAllSelected = products.every(x => x.isSelected)
      this.isSelectAll = isAllSelected
    },
    createSupplierOrder () {
      if (this.$refs.supplierOrderRef.$refs.validateForm.validate() && this.$refs.orderItems.validate()) {
        this.createOrderObj = {
          dialog: true,
          createAndEmail: () => {
            this.saveOrderItemsHandler(true)
          },
          createOnly: () => {
            this.saveOrderItemsHandler(false)
          },
          onCancel: () => {
            this.createOrderObj.dialog = false
          }
        }
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    }
  }
}
</script>
<style>
.order_item_table .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  font-size: 14px;
  padding: 0 4px !important;
}
.order_item_table .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 35px !important;
}
.custom-max-width div#spDoc > div {
  max-width: 100%;
}
.order_item_table, .border{
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.adjust-unit-width {
  max-width: 5% !important;
  -ms-flex: 0 0 5% !important;
  flex: 0 0 5% !important;
}
.adjust-qty-width {
  -ms-flex: 0 0 6.5% !important;
  flex: 0 0 6.5% !important;
  max-width: 6.5% !important;
}
.adjust-product-width {
  -ms-flex: 0 0 18.5% !important;
  flex: 0 0 18.5% !important;
  max-width: 18.5% !important;
}
.text-right-align-price input {
  text-align: right !important;
}
.low-stock .row {
  margin: 0px !important;
}
</style>
